import { render, staticRenderFns } from "./ShrinkingCoreInterests.vue?vue&type=template&id=97974f32&scoped=true"
import script from "./ShrinkingCoreInterests.vue?vue&type=script&lang=js"
export * from "./ShrinkingCoreInterests.vue?vue&type=script&lang=js"
import style0 from "./ShrinkingCoreInterests.vue?vue&type=style&index=0&id=97974f32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97974f32",
  null
  
)

export default component.exports